

import { useTheme } from "@mui/material/styles";
import { Inbox } from "lucide-react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const EmptyState = ({ moduleName, filterType, canCreate }) => {
  const v2 = useTheme()?.pearlUi === "v2";
  const getMessage = () => {
    return `No ${moduleName.toLowerCase()} exist. Please create a new one to display here.`;
  };

  if (v2) {
    return (
      <MDBox display="flex" flexDirection="column" alignItems="center" justifyContent="center" textAlign="center" px={3} py={5} gap={1}>
        <MDBox
          sx={{ width: 44, height: 44, borderRadius: "10px", display: "grid", placeItems: "center", bgcolor: "#E6EFFB", color: "#1453A0" }}
        >
          <Inbox size={22} aria-hidden="true" />
        </MDBox>
        <MDTypography variant="h6" fontWeight="medium">
          No {moduleName.toLowerCase()} yet
        </MDTypography>
        <MDTypography variant="body2" color="text">
          {canCreate === false
            ? "Nothing to show here yet."
            : `Create one and it will appear here.`}
        </MDTypography>
      </MDBox>
    );
  }

  return (
    <MDBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      p={3}
      sx={{ height: '100px' }}
    >
      <MDTypography variant="body2" color="text" fontWeight="regular">
        {getMessage()}
      </MDTypography>
    </MDBox>
  );
};

export default EmptyState;